import { type Psbt, Transaction, payments } from 'bitcoinjs-lib';

type GetSigHashTypeParams = {
  input: Psbt['data']['inputs'][0];
};

/**
 * This method will return the signature hash type for the current input.
 * If there is a sighashType, it will return that
 * If there is a witnessUtxo AND it is a taproot address, then it will return SIGHASH_DEFAULT
 * Otherwise, it will return SIGHASH_ALL
 */
export const getSigHashType = ({ input }: GetSigHashTypeParams) => {
  if (input?.sighashType) {
    return input.sighashType;
  }

  let isTaprootAddress = false;

  if (input.witnessUtxo?.script) {
    try {
      payments.p2tr({
        output: input.witnessUtxo.script,
      });
      isTaprootAddress = true;
    } catch {
      // do nothing - address is not taproot
    }
  }

  return isTaprootAddress
    ? Transaction.SIGHASH_DEFAULT
    : Transaction.SIGHASH_ALL;
};
